<template>
  <div :style="style" class="banner">
    <img :src="imgUrl" style="width: 100%" />
    <button class="edit-section">
      <img
        src="@/assets/icons/menu/edit-white.svg"
        class="edit-section"
        style="z-index: 100"
        @click="openModal()"
      />
    </button>

    <div class="edit-color">
      <el-color-picker v-model="style.backgroundColor" />
    </div>
  </div>
</template>

<script>
import { bus } from '@/main';

export default {
  name: 'Banner',
  props: {
    background: {
      type: String,
      required: false,
      default: '#1226aa',
    },
  },
  data() {
    return {
      imgUrl: '',
      color1: '',
      style: {
        height: this.height,
        backgroundColor: '#1226aa',
      },
      modalBanner: false,
    };
  },
  created() {
    let localImg = localStorage.getItem('bannerImg');
    this.imgUrl = localImg;

    bus.$on('novoBanner', (data) => {
      localStorage.setItem('bannerImg', data.titulo);
      this.imgUrl = data.titulo;
      this.modalBanner = false;
    });

    bus.$on('novoModulo', (data) => {
      this.modulos.push(data);
    });
  },
  methods: {
    openModal() {
      this.$root.$emit('modal', {
        component: 'Layout/Modais/Componentes/Banner.vue',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  border-radius: 4px;
  position: relative;
  height: 200px;

  .edit-section {
    position: absolute;
    top: 3%;
    right: 1.5%;
    cursor: pointer;
    background: transparent;
    border: none;
  }
}
.edit-color {
  position: absolute;
  top: 12%;
  right: 1.5%;
}

@media (max-width: 768px) {
  .banner {
    height: 180px;
  }
}
</style>